import { State } from "@features/base/types";
import {
  getWithdrawalsApi,
  merchantWithdrawalApi,
  Withdrawal,
  WithdrawalForm,
  WithdrawalParameters,
  WithdrawalResponse,
  WithdrawalsResponse,
} from "./api";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getWithdrawals = createAsyncThunk<
  WithdrawalsResponse,
  { userId: string; data?: WithdrawalParameters }
>(
  "withdrawals/getWithdrawals",
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      return await getWithdrawalsApi(userId, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const merchantWithdrawal = createAsyncThunk<
  WithdrawalResponse,
  { userId: string; data: WithdrawalForm }
>(
  "withdrawals/merchantWithdrawal",
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      return await merchantWithdrawalApi(userId, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type WithdrawalState = State<{
  withdrawals: Withdrawal[] | null;
  page: number;
  count: number;
  isFulfilledWithdrawal: string | null;
  isWithdrawalLoading: boolean;
}>;

const initialState: WithdrawalState = {
  withdrawals: null,
  loading: false,
  error: null,
  isFulfilledWithdrawal: null,
  isWithdrawalLoading: false,
  page: 1,
  count: 0,
};

const withdrawalsSlice = createSlice({
  name: "withdrawals",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWithdrawals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWithdrawals.fulfilled, (state, action) => {
        state.loading = false;
        state.withdrawals = action.payload.orders;
        state.page = action.payload.page;
        state.count = action.payload.count;
      })
      .addCase(getWithdrawals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(merchantWithdrawal.pending, (state) => {
        state.isWithdrawalLoading = true;
      })
      .addCase(merchantWithdrawal.fulfilled, (state, action) => {
        state.isWithdrawalLoading = false;
        state.isFulfilledWithdrawal = action.payload;
      })
      .addCase(merchantWithdrawal.rejected, (state, action) => {
        state.isWithdrawalLoading = false;
        state.isFulfilledWithdrawal = null;
        state.error = action.payload as string;
      });
  },
});

export default withdrawalsSlice.reducer;
